<template>
  <el-card class="form-card">
    <template #header>
      <div class="card-header">
        <div class="header-text">
          <h3>自主招生报名信息填报</h3>
          <p>请按要求填写后提交，提交后仍可修改。</p>
        </div>
        <div class="header-actions">
          <el-button type="primary" :loading="saving" @click="submitForm">提交</el-button>
          <el-button type="success" plain :loading="savingDraft" @click="saveDraft">保存草稿</el-button>
        </div>
      </div>
    </template>

    <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" class="enroll-form">
      <h4 class="section-title">一、学生基本信息</h4>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-select v-model="form.gender" placeholder="请选择性别">
          <el-option label="男" value="男" />
          <el-option label="女" value="女" />
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="form.phone" />
      </el-form-item>
      <el-form-item label="初中学校" prop="school">
        <el-input v-model="form.school" />
      </el-form-item>
      <el-form-item label="身份证号" prop="id_card">
        <el-input v-model="form.id_card" />
      </el-form-item>
      <el-form-item label="户籍地址" prop="address">
        <el-input v-model="form.address" />
      </el-form-item>

      <h4 class="section-title">二、家长信息</h4>
      <el-form-item label="父亲姓名" prop="father_name">
        <el-input v-model="form.father_name" />
      </el-form-item>
      <el-form-item label="父亲学历" prop="father_edu">
        <el-input v-model="form.father_edu" />
      </el-form-item>
      <el-form-item label="父亲工作单位" prop="father_work">
        <el-input v-model="form.father_work" />
      </el-form-item>
      <el-form-item label="父亲联系电话" prop="father_phone">
        <el-input v-model="form.father_phone" />
      </el-form-item>
      <el-form-item label="母亲姓名" prop="mother_name">
        <el-input v-model="form.mother_name" />
      </el-form-item>
      <el-form-item label="母亲学历" prop="mother_edu">
        <el-input v-model="form.mother_edu" />
      </el-form-item>
      <el-form-item label="母亲工作单位" prop="mother_work">
        <el-input v-model="form.mother_work" />
      </el-form-item>
      <el-form-item label="母亲联系电话" prop="mother_phone">
        <el-input v-model="form.mother_phone" />
      </el-form-item>

      <h4 class="section-title">三、初中成绩</h4>
      <el-table :data="form.grades" border class="grade-table">
        <el-table-column prop="stage" label="考试阶段" min-width="120">
          <template #default="{ row }">
            <el-input v-model="row.stage" />
          </template>
        </el-table-column>
        <el-table-column label="语文" min-width="80">
          <template #default="{ row }">
            <el-input v-model="row.chinese" />
          </template>
        </el-table-column>
        <el-table-column label="数学" min-width="80">
          <template #default="{ row }">
            <el-input v-model="row.math" />
          </template>
        </el-table-column>
        <el-table-column label="外语" min-width="80">
          <template #default="{ row }">
            <el-input v-model="row.english" />
          </template>
        </el-table-column>
        <el-table-column label="物理" min-width="80">
          <template #default="{ row }">
            <el-input v-model="row.physics" />
          </template>
        </el-table-column>
        <el-table-column label="化学" min-width="80">
          <template #default="{ row }">
            <el-input v-model="row.chemistry" />
          </template>
        </el-table-column>
        <el-table-column label="总分" min-width="80">
          <template #default="{ row }">
            <el-input v-model="row.total" />
          </template>
        </el-table-column>
      </el-table>

      <h4 class="section-title">四、荣誉与自述</h4>
      <el-form-item label="市/区级荣誉" prop="honor">
        <el-input
          v-model="form.honor"
          type="textarea"
          maxlength="500"
          show-word-limit
          :rows="6"
          placeholder="注明荣誉名称、时间，若未获此称号请填“无”"
        />
      </el-form-item>
      <el-form-item label="学生基本情况" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          maxlength="500"
          show-word-limit
          :rows="8"
          placeholder="结合孩子特点进行描述"
        />
      </el-form-item>

      <h4 class="section-title">五、材料上传</h4>
      <el-form-item label="上传PDF材料" class="upload-item">
        <el-upload
          :action="ENROLL_UPLOAD_ACTION"
          :headers="uploadHeaders"
          :file-list="fileList"
          :show-file-list="true"
          :limit="1"
          accept=".pdf"
          :before-upload="beforeUpload"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :on-change="handleUploadChange"
        >
          <el-button type="primary">上传 PDF 文件</el-button>
          <template #tip>
            <div class="el-upload__tip">仅支持 PDF，大小不超过 10MB</div>
          </template>
        </el-upload>
      </el-form-item>

      <EnrollmentPdfPreview
        v-if="previewUrl"
        :url="previewUrl"
        title="已上传材料"
        :height="560"
      />

      <el-form-item class="footer-actions">
        <el-button type="primary" :loading="saving" @click="submitForm">提交</el-button>
        <el-button type="success" plain :loading="savingDraft" @click="saveDraft">保存草稿</el-button>
        <el-button @click="loadForm">重置为已保存内容</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { ElMessage, ElNotification } from 'element-plus'
import { ENROLL_UPLOAD_ACTION, enrollmentStudentApi, resolveEnrollUrl } from '@/api'
import { getEnrollToken } from '@/utils/auth'
import EnrollmentPdfPreview from '@/components/EnrollmentPdfPreview.vue'

const formRef = ref()
const saving = ref(false)
const savingDraft = ref(false)
const fileList = ref([])
const previewUrl = ref('')

const defaultGrades = () => [
  { stage: '初三一模', chinese: '', math: '', english: '', physics: '', chemistry: '', total: '' },
  { stage: '初三二模', chinese: '', math: '', english: '', physics: '', chemistry: '', total: '' }
]

const form = ref({
  name: '',
  gender: '',
  phone: '',
  school: '',
  id_card: '',
  address: '',
  father_name: '',
  father_edu: '',
  father_work: '',
  father_phone: '',
  mother_name: '',
  mother_edu: '',
  mother_work: '',
  mother_phone: '',
  honor: '',
  description: '',
  grades: defaultGrades()
})

const idCardRule = [
  { required: true, message: '请输入身份证号', trigger: 'blur' },
  {
    pattern: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])([0-2][1-9]|10|20|30|31)\d{3}([0-9Xx])$/,
    message: '身份证号格式不正确',
    trigger: 'blur'
  }
]
const phoneRule = [
  { required: true, message: '请输入联系电话', trigger: 'blur' },
  {
    pattern: /^1[3-9]\d{9}$/,
    message: '手机号格式不正确',
    trigger: 'blur'
  }
]

const rules = {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
  id_card: idCardRule,
  phone: phoneRule,
  school: [{ required: true, message: '请输入初中学校', trigger: 'blur' }],
  address: [{ required: true, message: '请输入户籍地址', trigger: 'blur' }],
  father_name: [{ required: true, message: '请输入父亲姓名', trigger: 'blur' }],
  father_edu: [{ required: true, message: '请输入父亲学历', trigger: 'blur' }],
  father_work: [{ required: true, message: '请输入父亲工作单位', trigger: 'blur' }],
  father_phone: phoneRule,
  mother_name: [{ required: true, message: '请输入母亲姓名', trigger: 'blur' }],
  mother_edu: [{ required: true, message: '请输入母亲学历', trigger: 'blur' }],
  mother_work: [{ required: true, message: '请输入母亲工作单位', trigger: 'blur' }],
  mother_phone: phoneRule,
  honor: [{ required: true, message: '请输入荣誉，若无请填无', trigger: 'blur' }],
  description: [{ required: true, message: '请输入学生基本情况', trigger: 'blur' }]
}

const uploadHeaders = computed(() => ({
  Authorization: `Bearer ${getEnrollToken()}`
}))

const sanitizePayload = (payload) => ({
  ...payload,
  grades: (payload.grades || []).map((item) => ({
    stage: item.stage || '',
    chinese: item.chinese === '' ? null : Number(item.chinese),
    math: item.math === '' ? null : Number(item.math),
    english: item.english === '' ? null : Number(item.english),
    physics: item.physics === '' ? null : Number(item.physics),
    chemistry: item.chemistry === '' ? null : Number(item.chemistry),
    total: item.total === '' ? null : Number(item.total)
  }))
})

const loadForm = async () => {
  const data = await enrollmentStudentApi.getForm()
  form.value = {
    name: data.name || '',
    gender: data.gender || '',
    phone: data.phone || '',
    school: data.school || '',
    id_card: data.id_card || '',
    address: data.address || '',
    father_name: data.father_name || '',
    father_edu: data.father_edu || '',
    father_work: data.father_work || '',
    father_phone: data.father_phone || '',
    mother_name: data.mother_name || '',
    mother_edu: data.mother_edu || '',
    mother_work: data.mother_work || '',
    mother_phone: data.mother_phone || '',
    honor: data.honor || '',
    description: data.description || '',
    grades: (data.grades || []).length
      ? data.grades.map((g) => ({
        stage: g.stage || '',
        chinese: g.chinese ?? '',
        math: g.math ?? '',
        english: g.english ?? '',
        physics: g.physics ?? '',
        chemistry: g.chemistry ?? '',
        total: g.total ?? ''
      }))
      : defaultGrades()
  }

  if (data.file_path) {
    previewUrl.value = resolveEnrollUrl(`/api/enrollment/uploads/${data.file_path}`)
    fileList.value = [{ name: '已上传材料.pdf', url: previewUrl.value }]
  } else {
    previewUrl.value = ''
    fileList.value = []
  }
}

const submitForm = () => {
  formRef.value.validate(async (valid) => {
    if (!valid) {
      ElMessage.error('请先修正表单错误后提交')
      return
    }

    saving.value = true
    try {
      await enrollmentStudentApi.saveForm(sanitizePayload(form.value))
      ElNotification({
        title: '提交成功',
        message: '报名信息已保存，等待审核。',
        type: 'success'
      })
      await loadForm()
    } finally {
      saving.value = false
    }
  })
}

const saveDraft = async () => {
  savingDraft.value = true
  try {
    await enrollmentStudentApi.saveDraft(sanitizePayload(form.value))
    ElMessage.success('草稿已保存')
  } finally {
    savingDraft.value = false
  }
}

const beforeUpload = (file) => {
  const isPDF = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isPDF) {
    ElMessage.error('只能上传 PDF 文件')
  }
  if (!isLt10M) {
    ElMessage.error('文件大小不能超过 10MB')
  }
  return isPDF && isLt10M
}

const handleUploadSuccess = (response) => {
  previewUrl.value = resolveEnrollUrl(response.file_url)
  ElMessage.success('材料上传成功')
}

const handleUploadChange = (file, files) => {
  fileList.value = files
}

const handleUploadError = () => {
  ElMessage.error('上传失败，请重试')
}

onMounted(() => {
  loadForm()
})
</script>

<style scoped>
.form-card {
  border-radius: 18px;
  box-shadow: 0 18px 45px rgba(30, 64, 175, 0.08);
  border: 1px solid rgba(191, 219, 254, 0.6);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.card-header h3 {
  font-size: 22px;
  color: #0b3a73;
}

.card-header p {
  color: #5b6b86;
  margin-top: 6px;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.enroll-form h4 {
  margin: 22px 0 14px;
  color: #1e3a8a;
}

.section-title {
  padding: 10px 14px;
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.1), rgba(56, 189, 248, 0.06));
  border-radius: 12px;
  border-left: 4px solid #2563eb;
}

:deep(.enroll-form .el-form-item) {
  margin-bottom: 18px;
}

:deep(.enroll-form .el-form-item__label) {
  font-weight: 600;
  color: #334155;
}

:deep(.grade-table .el-table__header-wrapper th) {
  background: #eff6ff;
  color: #1e3a8a;
}

.upload-item {
  padding: 12px;
  background: #f8fafc;
  border: 1px dashed #bfdbfe;
  border-radius: 12px;
}

.footer-actions {
  margin-top: 10px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-actions {
    width: 100%;
  }

  .header-actions .el-button {
    flex: 1;
  }

  :deep(.enroll-form .el-form-item) {
    margin-bottom: 14px;
  }
}

</style>
